import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  NEWS_PAGE_ADD_PATH,
  NEWS_PAGE_PATH,
  NEWS_PAGE_UPDATE_PATH,
} from "utils/constants/paths";

const NewsDetailsPage = Loadable(React.lazy(() => import("./View")));
const NewsDetailsPageAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const NewsRoute: IRouteItem = {
  path: NEWS_PAGE_PATH,
  element: React.createElement(NewsDetailsPage),
  name: "News Listing",
  children: [
    {
      name: "Add / Update",
      path: NEWS_PAGE_ADD_PATH,
      element: React.createElement(NewsDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: NEWS_PAGE_UPDATE_PATH,
      element: React.createElement(NewsDetailsPageAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
